import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import CommonHeaderComponent from '../headers/CommonHeaderComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PictureModeModal from '../core/PictureModeModal';
import ConfirmationModal from '../core/ConfirmationModal';
import IssueConfirmedModal from '../core/IssueConfirmedModal';
import * as actions from '../../actions/ordersAction';
import * as symbols from '../../operations/symbols';
import { PhotoViewer, PhotoMainViewer } from '../core/PhotoViewerComponent';
import './reason.scss';
import LoaderComponent from '../core/LoaderComponent';

class ReasonListPhotoView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reasonsList: {},
      currentOrder: null,
      openPictureModeModal: false,
      reasonImages: [],
      openDoneModal: false,
      openLoader: false,
      openConfirmationModal: false
    }
  }

  openPictureModeModal() {
    this.setState({ openPictureModeModal: true })
  }

  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  componentDidUpdate(prevProps) {
    const reasonId = this.props.match.params.reasonId;
    const { cancelDeliveryIssueStatus } = this.props;
    if (!prevProps.orders.reasonImages[reasonId] && JSON.stringify(prevProps.orders.reasonImages[reasonId]) != JSON.stringify(this.props.orders.reasonImages[reasonId])) {
      this.setState({ reasonImages: [...this.state.reasonImages, ...this.props.orders.reasonImages[reasonId]] }, () => {
        this.props.actions.resetOrderDetailImages();
      })
    }

    if (cancelDeliveryIssueStatus !== prevProps.cancelDeliveryIssueStatus && (cancelDeliveryIssueStatus === symbols.STATUS_DONE)) {
      this.setState({ openDoneModal: true, openPictureModeModal: false, openConfirmationModal: false })
    }

    if (cancelDeliveryIssueStatus !== prevProps.cancelDeliveryIssueStatus && (cancelDeliveryIssueStatus === symbols.STATUS_FAIL)) {
      this.setState({ openLoader: false })
    }


  }

  componentDidMount() {
    if (!this.props.orders.deliveryReasons) {
      this.props.history.push('/');
      return
    }


    const orderId = this.props.match.params.orderId;
    const reasonId = this.props.match.params.reasonId;

    let reasonsList = this.props.orders.deliveryReasons.reduce((acc, ele) => {
      acc[ele.id] = ele.name;
      return acc
    }, {})

    const currentOrder = this.props.orders && this.props.orders.orders.reduce((acc, ele, index) => {
      if (ele.orderId == orderId) {
        acc = ele
      }
      return acc

    }, {})
    this.setState({ reasonsList, currentOrder, reasonImages: this.props.orders.reasonImages[reasonId] }, () => {
      this.props.actions.resetOrderDetailImages();
    });
  }

  componentWillUnmount() {
    this.props.actions.resetOrderDetailImages();
  }

  removeImage(e, currIndex) {
    let reasonImages = [...this.state.reasonImages];
    reasonImages = reasonImages.filter((ele, index) => {
      if (currIndex !== index) {
        return true
      }
    })
    this.setState({ reasonImages })
  }

  handleOnSubmit() {
    alert('')
  }


  // Modal operations
  closeConfirmationModal() {
    this.setState({ openConfirmationModal: false })
  }

  openConfirmationModal() {
    this.setState({ openConfirmationModal: true })
  }

  // cancel delivery
  cancelOrderDelivery() {
    const reasonId = this.props.match.params.reasonId;
    const orderId = this.props.match.params.orderId;
    const params = new FormData();
    for (let i in this.state.reasonImages) {
      params.append('files', this.state.reasonImages[i])
    }
    params.append('reasonId', reasonId);
    this.setState({ openLoader: true })
    this.props.actions.cancelOrderDelivery(orderId, params);
  }


  render() {
    const { orders } = this.props;
    const reasonId = this.props.match.params.reasonId;
    const orderId = this.props.match.params.orderId;
    const { reasonsList, openPictureModeModal, openConfirmationModal, openDoneModal } = this.state;

    return (
      <div className="hp-container pd-top-global">
        <CommonHeaderComponent
          enableBack={true}
          icon={'times'}
          title={Object.keys(reasonsList).length > 0 && reasonsList[reasonId]}
        />
        <PictureModeModal
          isOpen={openPictureModeModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          hasSameRoute={true}
          id={reasonId}
          type="reason"
        />
        <ConfirmationModal
          isOpen={openConfirmationModal}
          closeConfirmationModal={() => this.closeConfirmationModal()}
          cancelOrderDelivery={() => this.cancelOrderDelivery()}
          openLoader={this.state.openLoader}
          error={this.props.cancelDeliveryIssueError ? this.props.cancelDeliveryIssueError.error : null}
        />
        <IssueConfirmedModal
          history={this.props.history}
          isOpen={openDoneModal}
        />
        <div className="reason-photo-wrapper order-top-header">
          <div className="order-photos">
            <div className="subtitle">
              <b>Add Photos</b>
            </div>
            <div className="horizontal-scroll">
            <div className="order-photo-wrapper">
              <div 
                className="gallery-item order-photo-ele order-photo-placeholder"
                onClick={() => this.openPictureModeModal()}
              >
                  <FontAwesomeIcon icon="camera" />
              </div>
            </div>
            
            {
              this.state.reasonImages && this.state.reasonImages.map((ele, index) => {
                return(
                  <div className="order-photo-wrapper" key={index}>
                      <div className="cross-image" onClick={(e) => this.removeImage(e, index)}>
                          <FontAwesomeIcon icon="times" />
                      </div>
                      <div className={`gallery-item order-photo-ele`} style={{'backgroundImage': 'url('+URL.createObjectURL(ele)+')'}}>
                    </div>
                  </div>
                )     
              })
            }
            </div>
          </div>
        </div>

         <div className="order-card fixed-verify-section z-index-9 flex-column">
            <div className="mb-2">We will inform hyperpure that the <b>restaurant is closed</b></div>
            {this.state.openLoader ? <LoaderComponent /> :
            <div
              className={this.state.reasonImages.length > 0 ? "btn btn-expand btn-green" : "btn btn-expand btn-disabled"}
              onClick={() => this.cancelOrderDelivery()}
            >Confirm Re-Attempt</div>
            }
            </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    cancelDeliveryIssueStatus: state.statuses.cancelDeliveryIssue.status,
    cancelDeliveryIssueError: state.statuses.cancelDeliveryIssue.errors,
    orders: state.orders
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  }),
)(ReasonListPhotoView));
